import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  template: `
    <glxy-page [pagePadding]="false">
      <glxy-page-toolbar>
        <glxy-page-title>Notifications</glxy-page-title>

        <glxy-page-actions>
          <div class="actions">
            <a mat-stroked-button routerLink="/notifications/create" color="primary">Create</a>
          </div>
        </glxy-page-actions>
      </glxy-page-toolbar>

      <glxy-page-wrapper widthPreset="full">
        <notification-type-list editRoute="/notifications/edit/" releaseRoute="/notifications/release/" />
      </glxy-page-wrapper>
    </glxy-page>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ListComponent {}
